import { StringBase } from '../StringBase';
import { ArrayBase } from '../ArrayBase';
import { Base } from '../Base';

export class FlipOTT extends Base {
  precreated = null;
  custom = null;

   isValid() {
    return (this.custom && this.custom.length > 0) || (this.precreated && this.precreated.length > 0);
  }

  static count(target) {
    let len = 0;
    if (target && target.custom) {
      len = StringBase.count(target.custom);
    }

    if (target && target.precreated) {
        len = len + ArrayBase.count(target.precreated);
    }
    return len;
  }
  static isEqual(a, b) {
    const eq = Base.isEqual(a, b);
    if (eq !== undefined) {
      return eq;
    }
    return JSON.stringify(a) === JSON.stringify(b);
  }
}
